/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const LocalizationIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="LocalizationIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8ZM9.22689 11.7954C8.73715 12.7749 8.2456 13 8 13C7.7544 13 7.26285 12.7749 6.77311 11.7954C6.36393 10.9771 6.0708 9.82551 6.01118 8.5H9.98882C9.9292 9.82551 9.63607 10.9771 9.22689 11.7954ZM9.98882 7.5H6.01118C6.0708 6.17449 6.36393 5.02293 6.77311 4.20457C7.26285 3.22509 7.7544 3 8 3C8.2456 3 8.73715 3.22509 9.22689 4.20457C9.63607 5.02293 9.9292 6.17449 9.98882 7.5ZM10.9897 8.5C10.9215 10.1551 10.5173 11.6198 9.91388 12.6206C11.5789 11.9302 12.79 10.366 12.9753 8.5H10.9897ZM12.9753 7.5H10.9897C10.9215 5.84488 10.5173 4.38024 9.91388 3.37938C11.5789 4.06981 12.79 5.63401 12.9753 7.5ZM5.01027 7.5C5.07854 5.84488 5.48271 4.38024 6.08612 3.37938C4.42109 4.06981 3.20995 5.63401 3.02469 7.5H5.01027ZM3.02469 8.5C3.20995 10.366 4.42109 11.9302 6.08612 12.6206C5.48271 11.6198 5.07854 10.1551 5.01027 8.5H3.02469Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

LocalizationIcon.tags = [
  'globe',
  'earth',
  'language',
  'world',
  'international',
  'network',
  'map',
];

LocalizationIcon.category = 'General Icons';

LocalizationIcon.iconSize = 16;
